import React from "react";
import Nav from "./nav";
import SidebarTwo from "./Sidebar2";
import OverviewBatteries from "./OverviewBattery";
import ClientBatteries from "./ClientBatteries";
import { useContext } from "react";
import { MyContext } from "../../context";
import ClientSidebar from "./ClientSidebar";
import ClientInstallation from "./ClientInstallation";
import ClientOverview from "./ClientOverview";
import ClientReport from "./ClientReport"
import ClientSetting from "./ClientSetting"
import TicketSidebar from "./TicketSidebar"
import TicketOverview from "./TicketOverview";
import MyTicket from "./TicketMyTicket"
import TicketNav from "./TicketNav"



function TicketDashboard() {
  const { LinkSelection } = useContext(MyContext);

  let SideBarLink = () => {
    switch (LinkSelection) {
      case "":
        return (
          <>
           <TicketOverview /> 
          </>
        );
        break;

      case "Myticket":
        return (
          <>
            <MyTicket />
          </>
        );
        break;

        case "Setting":
        return (
          <>
            <ClientSetting />
          </>
        );
        break;

        

        
    }
  };

  return (
    <>
      <TicketNav />
      <div className="wrap">
        <div className="sideWrap">
         <TicketSidebar />
        </div>

        <div className="contentWrap" style={{ width: "100%" }}>
          {SideBarLink()}
        </div>
      </div>
    </>
  );
}

export default TicketDashboard;
